var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66927 11.9987C7.85259 11.9985 9.00181 11.6023 9.93394 10.8734L12.8646 13.804L13.8073 12.8614L10.8766 9.9307C11.6059 8.99847 12.0023 7.84899 12.0026 6.66536C12.0026 3.7247 9.60994 1.33203 6.66927 1.33203C3.7286 1.33203 1.33594 3.7247 1.33594 6.66536C1.33594 9.60603 3.7286 11.9987 6.66927 11.9987ZM6.66927 2.66536C8.87527 2.66536 10.6693 4.45936 10.6693 6.66536C10.6693 8.87136 8.87527 10.6654 6.66927 10.6654C4.46327 10.6654 2.66927 8.87136 2.66927 6.66536C2.66927 4.45936 4.46327 2.66536 6.66927 2.66536Z",
    fill: "#74788D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60658 5.7221C7.85925 5.97544 7.99858 6.3101 7.99858 6.66477H9.33192C9.33251 6.31439 9.26364 5.96737 9.1293 5.64376C8.99496 5.32016 8.79781 5.02639 8.54925 4.77944C7.53992 3.77144 5.78992 3.77144 4.78125 4.77944L5.72258 5.72344C6.22925 5.2181 7.10258 5.21944 7.60658 5.7221Z",
    fill: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.013e868cf2947f37b40a8eb66aaba4cb.svg";
export { ForwardRef as ReactComponent };